import { render, staticRenderFns } from "./share-buttons.vue?vue&type=template&id=7f7dfd21&"
import script from "./share-buttons.vue?vue&type=script&lang=js&"
export * from "./share-buttons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports